import MicroModal from 'micromodal';

(function() {
	MicroModal.init({
		disableScroll: true,
		awaitCloseAnimation: true,
		onClose: () => {
			const buttons = document.querySelectorAll('[data-js~="modal-button"]');
			buttons.forEach(button => {
				button.blur();
			});
		}
	});

	/*
	datajs('mc-embedded-subscribe-form').addEventListener('submit', function(e) {
		MicroModal.close('contact-modal');
		modalButton.blur();
	});
	*/
})();
